import { DEFAULT_USER } from 'common/mocks/authentication';
import {ENVIRONMENTS} from 'common/domain/constants';

const STATES = {
  READ_ONLY: 'READ_ONLY',
  EDITABLE: 'EDITABLE'
};

class DevChangeEmployeeController {
  constructor($cookies, $window) {
    'ngInject';
    this.cookies = $cookies;
    this.window = $window;

    this.initUser();
    this.env = ENVIRONMENTS[process.env.name];
    this.version = process.env.version;
  }

  initUser() {
    this.employeeId = this.cookies.get('userId') ? this.cookies.get('userId') : DEFAULT_USER;
    this.status = STATES.READ_ONLY;
  }

  isReadOnly() {
    return this.status === STATES.READ_ONLY;
  }

  isEditable() {
    return this.status === STATES.EDITABLE;
  }

  edit(){
    this.status = STATES.EDITABLE;
  }

  cancel() {
    this.initUser();
  }

  changeUser(){
    this.cookies.put('userId', this.employeeId);
    this.status = STATES.READ_ONLY;
    this.window.location.reload();
  }
}

export default DevChangeEmployeeController;



// WEBPACK FOOTER //
// ./client/app/features/mainRouting/index/devChangeEmployee/devChangeEmployee.controller.js